<template>
  <div class="progress-circular">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewbox="0 0 40 40"
    >
      <path class="trail" d="M8,32 A16,16 0 1,1 32,32" />
      <path
        class="path"
        d="M8,32 A16,16 0 1,1 32,32"
        :style="{
          stroke: !rank
            ? state.colors[
                Math.floor((value_display - 1) / state.colors.length)
              ]
            : state.rank_colors[rank],
          'stroke-dashoffset': 73 - (73 * value_display) / 100,
        }"
      />
    </svg>
    <span class="value" v-text="label || Math.floor(value_display)" />
  </div>
</template>

<script setup>
import { reactive, computed } from "vue";

const props = defineProps({
  value: {
    type: Number,
    required: true,
  },
  rank: {
    type: String,
  },
  label: {
    type: String,
  },
});

const state = reactive({
  colors: [
    "#822312",
    "#822312",
    "#CD5500",
    "#CD5500",
    "#EDAE39",
    "#EDAE39",
    "#92C93A",
    "#92C93A",
    "#00AF00",
    "#00AF00",
  ],
  rank_colors: {
    A: "#00AF00",
    B: "#92C93A",
    C: "#EDAE39",
    D: "#CD5500",
    E: "#822312",
  },
});

const value_display = computed(() => {
  return props.value > 3 ? props.value : 3;
});
</script>
